import * as types from '../mutation-types'

const state = {
  resumes: [{}, {}, {}, {}],
  showCompare: 0,
  post: "-1"
};
const getters = {
  compareReumes: state => state.resumes,
  selectPost: state => state.post,
  showCompare: state => state.showCompare // 显示
};

const actions = {
  addCompareResume: function ({
    commit
  }, resume) {
    commit(types.ADD_COMPARE_RESUME, resume)
  },
  delCompareResume: function ({
    commit
  }, index) {
    commit(types.REMOVE_COMPARE_RESUME, index)
  },
  clearCompareResumes: function ({
    commit
  }) {
    commit(types.CLEAR_COMPARE_RESUMES)
  },
  hideCompareResumesBar: function ({
    commit
  }) {
    commit(types.HIDE_COMPARE_RESUMES_BAR)
  }
}

const mutations = {
  [types.ADD_COMPARE_RESUME](state, resume) { // 设置resume
    if (resume) {
      state.showCompare = 1;
      for (let i = 0; i < 4; i++) {
        let tmp = state.resumes[i];
        if (tmp.code === resume.code) {
          break;
        }
        if (!tmp.code) {
          state.resumes.splice(i, 1, resume);
          break;
        }
      }
      state.post = state.resumes[0].post_id
    }
  },
  [types.REMOVE_COMPARE_RESUME](state, index) { // 移除resume
    if (index >= 0 && state.resumes.length > index) {
      state.resumes.splice(index, 1)
      state.resumes.push({})
    }
    if (!state.resumes[0].post_id) {
      state.post = "-1"
    }
  },
  [types.CLEAR_COMPARE_RESUMES](state) {
    state.resumes = state.resumes.map(() => ({}))
    state.post = "-1"
  },
  [types.HIDE_COMPARE_RESUMES_BAR](state) {
    state.showCompare = 0;
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/company.js